<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :value="unit"
                :options="unitOptionsNew"
                native
                @input="onUnitInput"
            />
        </template>

        <template slot="primary">
            <collapse id="control-max-width" v-model="slider">
                <slider
                    :value="sliderIndex"
                    :values="themeObjectValues"
                    @input="onInput"
                />
            </collapse>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'max-width',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Max Width',
            tailwindDefinitionProp: 'maxWidth',
            defaultUnit: 'rem',
        };
    },

    computed: {
        unitOptionsNew() {
            const options = this.unitOptions;

            options.unshift({ text: 'None', value: '' });

            return options;
        },
    },

    watch: {
        changedOption({ option }) {
            if (option === 'min-width') this.onConflict();
        },
    },

    methods: {
        onConflict() {
            this.removeFlexClass();
            this.sliderIndex = 0;
            this.unit = this.defaultUnit;
        },
    },
};
</script>
